import React from 'react';
import PropTypes from 'prop-types';

import Item from '../react-event-item';

import './index.scss';

/**
 * A list of event-item
 */

const EventList = ({onEventItemClick, containerType, events, eventType, ...eventItemOptions}) =>
  !events || !events.length
    ? null
    : events.map((event, index) => {
        return (
          <Item
            event={event}
            key={event.id}
            eventType={eventType}
            onClick={() => onEventItemClick && onEventItemClick(event, index)}
            {...eventItemOptions}
          />
        );
      });

EventList.propTypes = {
  events: PropTypes.array,
  threshold: PropTypes.number,
  type: PropTypes.string,
  onEventItemClick: PropTypes.func,

  /**
   * Options Containing the Parts of the Event Items to be Hidden
   */
  eventItemDisplayOptions: PropTypes.object,
  containerType: PropTypes.string,
  eventType: PropTypes.string,
};

export default EventList;
